import { TextField } from '@shinetools/lumen-react'
import { useTranslation } from 'react-i18next'

import { DesignSystem } from '../../../../../../../../../../../../../../enums/designSystem'
import { useFormContext } from '../../../../../../../../../../../../../../hooks/useForm'
import type { SupplierFormSchema } from '../../../../../../types/supplierForm'

export const CompanyVatNo = () => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<SupplierFormSchema, DesignSystem.Lumen>({ designSystem: DesignSystem.Lumen })

  return (
    <FormItem
      name="vatNo"
      render={({ error, field }) => (
        <TextField
          {...field}
          error={error}
          label={t('suppliers.detail.form.tax_id.label')}
          placeholder={t('suppliers.detail.form.tax_id.placeholder')}
          size="small"
        />
      )}
    />
  )
}
